import { UnityFeatureType } from '@unity/clients';
import { AuthGuard } from '@unity/middleware/auth.guard';
import { FeatureGuard } from '@unity/middleware/feature.guard';
import { FormChangesDeactivateGuard } from '@unity/middleware/form-changes.deactivate.guard';
import { PermissionGuard } from '@unity/middleware/permission.guard';
import { ListAgencyPageComponent } from '@unity/pages/list-agency-page/list-agency-page.component';
import { ListAgreementFormSchedulesPageComponent } from '@unity/pages/list-agreement-form-schedules-page/list-agreement-form-schedules-page.component';
import { ListAgreementPageComponent } from '@unity/pages/list-agreement-page/list-agreement-page.component';
import { ListAgreementUsersPageComponent } from '@unity/pages/list-agreement-users-page/list-agreement-users-page.component';
import { ListClientExpensePageComponent } from '@unity/pages/list-client-expense-page/list-client-expense-page.component';
import { ListClientPageComponent } from '@unity/pages/list-client-page/list-client-page.component';
import { ListCommunityPageComponent } from '@unity/pages/list-community-page/list-community-page.component';
import { ListDisbursementPageComponent } from '@unity/pages/list-disbursement-page/list-disbursement-page.component';
import { ListDocumentPageComponent } from '@unity/pages/list-document-page/list-document-page';
import { ListFormTemplatePageComponent } from '@unity/pages/list-form-template-page/list-form-template-page.component';
import { ListProgramPageComponent } from '@unity/pages/list-program-page/list-program-page.component';
import { ListReportPageComponent } from '@unity/pages/list-report-page/list-report-page.component';
import { ListUserPageComponent } from '@unity/pages/list-user-page/list-user-page.component';
import { ListVendorPageComponent } from '@unity/pages/list-vendor-page/list-vendor-page.component';
import { LoginConfirmUserPageComponent } from '@unity/pages/login-confirm-user-page/login-confirm-user-page.component';
import { LoginDisabledPageComponent } from '@unity/pages/login-disabled-page/login-disabled-page.component';
import { LoginPageComponent } from '@unity/pages/login-page/login-page.component';
import { LoginPendingPageComponent } from '@unity/pages/login-pending-page/login-pending-page.component';
import { LoginResendConfirmationPageComponent } from '@unity/pages/login-resend-confirmation-page/login-resend-confirmation-page.component';
import { LoginResetPasswordPageComponent } from '@unity/pages/login-reset-password-page/login-reset-password-page.component';
import { LoginSelectAgencyPageComponent } from '@unity/pages/login-select-agency-page/login-select-agency-page.component';
import { ManageAgencyPageComponent } from '@unity/pages/manage-agency-page/manage-agency-page.component';
import { ManageAgencyUserPageComponent } from '@unity/pages/manage-agency-user-page/manage-agency-user-page.component';
import { ManageAgreementPageComponent } from '@unity/pages/manage-agreement-page/manage-agreement-page.component';
import { ManageAgreementUserPageComponent } from '@unity/pages/manage-agreement-user-page/manage-agreement-user-page.component';
import { ManageClientExpensePageComponent } from '@unity/pages/manage-client-expense-page/manage-client-expense-page.component';
import { ManageClientPageComponent } from '@unity/pages/manage-client-page/manage-client-page.component';
import { ManageCommunityPageComponent } from '@unity/pages/manage-community-page/manage-community-page.component';
import { ManageDisbursementPageComponent } from '@unity/pages/manage-disbursement-page/manage-disbursement-page.component';
import { ManageFormResponsePageComponent } from '@unity/pages/manage-form-response-page/manage-form-response-page.component';
import { ManageFormSchedulePageComponent } from '@unity/pages/manage-form-schedule-page/manage-form-schedule-page.component';
import { ManageFormTemplatePageComponent } from '@unity/pages/manage-form-template-page/manage-form-template-page.component';
import { ManageProgramPageComponent } from '@unity/pages/manage-program-page/manage-program-page.component';
import { ManageReferenceFilePageComponent } from '@unity/pages/manage-reference-file-page/manage-reference-file-page.component';
import { ManageRolePageComponent } from '@unity/pages/manage-role-page/manage-role-page.component';
import { ManageUserPageComponent } from '@unity/pages/manage-user-page/manage-user-page.component';
import { ManageVendorPageComponent } from '@unity/pages/manage-vendor-page/manage-vendor-page.component';
import { NewAgencyPageComponent } from '@unity/pages/new-agency-page/new-agency-page.component';
import { NewAgreementPageComponent } from '@unity/pages/new-agreement-page/new-agreement-page.component';
import { NewAgreementUserPageComponent } from '@unity/pages/new-agreement-user-page/new-agreement-user-page.component';
import { NewClientExpensePageComponent } from '@unity/pages/new-client-expense-page/new-client-expense-page.component';
import { NewClientPageComponent } from '@unity/pages/new-client-page/new-client-page.component';
import { NewCommunityPageComponent } from '@unity/pages/new-community-page/new-community-page.component';
import { NewDisbursementPageComponent } from '@unity/pages/new-disbursement-page/new-disbursement-page.component';
import { NewDocumentPageComponent } from '@unity/pages/new-document-page/new-document-page.component';
import { NewFormInstancePageComponent } from '@unity/pages/new-form-instance-page/new-form-instance-page.component';
import { NewFormResponsePageComponent } from '@unity/pages/new-form-response-page/new-form-response-page.component';
import { NewFormSchedulePageComponent } from '@unity/pages/new-form-schedule-page/new-form-schedule-page.component';
import { NewFormTemplatePageComponent } from '@unity/pages/new-form-template-page/new-form-template-page.component';
import { NewProgramPageComponent } from '@unity/pages/new-program-page/new-program-page.component';
import { NewReferenceFilePageComponent } from '@unity/pages/new-reference-file-page/new-reference-file-page.component';
import { NewRolePageComponent } from '@unity/pages/new-role-page/new-role-page.component';
import { NewUserInternalPageComponent } from '@unity/pages/new-user-internal-page/new-user-internal-page.component';
import { NewUserPageComponent } from '@unity/pages/new-user-page/new-user-page.component';
import { NewUserRolePageComponent } from '@unity/pages/new-user-role-page/new-user-role-page.component';
import { NewVendorPageComponent } from '@unity/pages/new-vendor-page/new-vendor-page.component';
import { NotFoundPageComponent } from '@unity/pages/not-found-page/not-found-page.component';
import { ViewAgreementPageComponent } from '@unity/pages/view-agreement-page/view-agreement-page.component';
import { ViewDashboardPageComponent } from '@unity/pages/view-dashboard-page/view-dashboard-page.component';
import { MyAgencyResolver } from '@unity/resolvers/my-agency.resolver';
import { IndexComponent } from './components/index/index.component';
import { ListFormInstancePageComponent } from './components/pages/list-form-instance-page/list-form-instance-page.component';
import { DeactivateGuard } from './middleware/deactivate.guard';
import type { InsideUnityRoute, OutsideUnityRoute, UnityRoute } from './utils/types';

function addGuard(route: UnityRoute): UnityRoute {
  if (route.component || route.loadComponent) {
    route = {
      ...route,
      canActivate: [AuthGuard, PermissionGuard, ...(route.canActivate ?? [])],
      canDeactivate: [DeactivateGuard, FormChangesDeactivateGuard, ...(route.canDeactivate ?? [])],
    };
  }
  if (route.children && route.children.length) {
    route.children = route.children.map(addGuard);
  }
  return route;
}

function withGuards(routes: UnityRoute[]) {
  return routes.map(addGuard);
}

export const myBusinessData = {
  myBusiness: () => true,
};

// Outside (pre-login) routes are static, indexed might be dynamic based on user privilege
export const routes = (): OutsideUnityRoute[] => [
  ...outsideRoutes,
  {
    path: '',
    component: IndexComponent,
    children: [
      ...withGuards(insideRoutes),
      {
        // Redirect to home from root path (/home will take care of auth)
        path: '',
        pathMatch: 'full',
        redirectTo: '/agreement',
      },
      {
        // Inside route 404s
        path: '**',
        canActivate: [AuthGuard],
        component: NotFoundPageComponent,
      },
    ],
  },
];

export const outsideRoutes = [
  { path: 'login', component: LoginPageComponent },
  {
    path: 'reset-password',
    component: LoginResetPasswordPageComponent,
    canDeactivate: [FormChangesDeactivateGuard],
  },
  { path: 'confirm-user', component: LoginConfirmUserPageComponent },
  { path: 'resend-confirm', component: LoginResendConfirmationPageComponent },
  {
    path: 'login-select-business-partner',
    component: LoginSelectAgencyPageComponent,
  },
  { path: 'pending', component: LoginPendingPageComponent },
  { path: 'disabled', component: LoginDisabledPageComponent },
] as const satisfies OutsideUnityRoute[];

export const insideRoutes = [
  {
    path: 'agreement',
    children: [
      {
        path: '',
        component: ListAgreementPageComponent,
        data: {
          authorize: 'Agreement:List',
        },
      },
      {
        path: 'create',
        component: NewAgreementPageComponent,
        data: {
          authorize: 'Agreement:Create',
        },
      },
      {
        path: ':agreementId/view',
        component: ViewAgreementPageComponent,
        data: {
          authorize: 'Agreement:View',
        },
      },
      {
        path: ':agreementId',
        children: [
          {
            path: '',
            component: ManageAgreementPageComponent,
            data: {
              authorize: 'Agreement:View',
            },
          },
          {
            path: 'user',
            children: [
              {
                path: '',
                component: ListAgreementUsersPageComponent,
                data: {
                  authorize: 'Agreement:View',
                },
              },
              {
                path: ':userId',
                component: ManageAgreementUserPageComponent,
                data: {
                  authorize: 'Agreement:Create',
                },
              },
            ],
            data: {
              authorize: 'Agreement:View',
            },
          },
          {
            path: 'form-schedule/:formScheduleId/form',
            component: ListFormInstancePageComponent,
            data: {
              authorize: 'Agreement:View',
            },
          },
          {
            path: 'reference-file',
            children: [
              {
                path: '',
                component: ListDocumentPageComponent,
                data: {
                  authorize: 'Agreement:View',
                },
              },
              {
                path: 'create',
                component: NewReferenceFilePageComponent,
                data: {
                  authorize: 'ReferenceFile:Create',
                },
              },
              {
                path: ':referenceFileId',
                component: ManageReferenceFilePageComponent,
                data: {
                  authorize: 'ReferenceFile:View',
                },
              },
            ],
            data: {
              authorize: 'Agreement:View',
            },
          },
          {
            path: 'document',
            children: [
              {
                path: '',
                component: ListDocumentPageComponent,
                data: {
                  authorize: 'Agreement:View',
                },
              },
              {
                path: 'create',
                component: NewDocumentPageComponent,
                data: {
                  authorize: 'Document:Create',
                },
              },
              {
                path: ':documentId',
                loadComponent: () =>
                  import('@unity/pages/manage-document-page/manage-document-page.component').then(m => m.ManageDocumentPageComponent),
                data: {
                  authorize: 'Document:View',
                },
              },
            ],
            data: {
              authorize: 'Document:List',
            },
          },
          {
            path: 'client',
            children: [
              {
                path: '',
                component: ListClientPageComponent,
                data: {
                  authorize: 'Client:View',
                },
              },
              {
                path: 'create',
                component: NewClientPageComponent,
                data: {
                  authorize: 'Client:Create',
                },
              },
              {
                path: ':clientId',
                component: ManageClientPageComponent,
                data: {
                  authorize: 'Client:Update',
                },
              },
            ],
            data: {
              authorize: 'Client:View',
            },
          },
          {
            path: 'client-expense',
            children: [
              {
                path: '',
                component: ListClientExpensePageComponent,
                data: {
                  authorize: 'ClientExpense:View',
                },
              },
              {
                path: 'create',
                component: NewClientExpensePageComponent,
                data: {
                  authorize: 'ClientExpense:Create',
                },
              },
              {
                path: ':clientExpenseId',
                component: ManageClientExpensePageComponent,
                data: {
                  authorize: 'ClientExpense:Update',
                },
              },
            ],
            data: {
              authorize: 'ClientExpense:View',
            },
          },
          {
            path: 'disbursement',
            children: [
              {
                path: '',
                component: ListDisbursementPageComponent,
                data: {
                  authorize: 'Disbursement:View',
                },
              },
              {
                path: 'create',
                component: NewDisbursementPageComponent,
                data: {
                  authorize: 'Disbursement:Create',
                },
              },
              {
                path: ':disbursementId',
                component: ManageDisbursementPageComponent,
                data: {
                  authorize: 'Disbursement:Update',
                },
              },
            ],
            data: {
              authorize: 'Disbursement:View',
            },
          },
          {
            path: 'form',
            children: [
              {
                path: '',
                component: ListAgreementFormSchedulesPageComponent,
                data: {
                  authorize: 'Agreement:View',
                },
              },
              {
                path: 'create',
                component: NewFormSchedulePageComponent,
                data: {
                  authorize: 'FormSchedule:Create',
                },
              },
              {
                path: ':formId',
                component: ManageFormSchedulePageComponent,
                data: {
                  authorize: 'FormSchedule:View',
                },
              },
            ],
            data: {
              authorize: 'FormSchedule:View',
            },
          },
          {
            path: 'assign-user',
            component: NewAgreementUserPageComponent,
            data: {
              authorize: 'Agreement:Update',
            },
          },
          {
            path: 'form-instance/create',
            component: NewFormInstancePageComponent,
            data: {
              authorize: 'FormInstance:Create',
            },
          },
          {
            path: 'form-instance/:formInstanceId',
            loadComponent: () =>
              import('@unity/pages/manage-form-instance-page/manage-form-instance-page.component').then(
                m => m.ManageFormInstancePageComponent
              ),
            data: {
              authorize: 'FormInstance:View',
            },
          },
          {
            path: 'form-schedule/:formScheduleId/form/create',
            component: NewFormResponsePageComponent,
            data: {
              authorize: 'FormResponse:Create',
            },
          },
          {
            path: 'form-schedule/:formScheduleId/form-instance/:formInstanceId/form/create',
            component: NewFormResponsePageComponent,
            data: {
              authorize: 'FormResponse:Create',
            },
          },
          {
            path: 'form-instance/:formInstanceId/form-response/:formResponseId',
            component: ManageFormResponsePageComponent,
            data: {
              authorize: 'FormResponse:Update',
            },
          },
        ],
      },
    ],
  },
  {
    path: 'form-template',
    children: [
      {
        path: '',
        component: ListFormTemplatePageComponent,
        data: {
          authorize: 'FormSchema:List',
        },
      },
      {
        path: 'create',
        component: NewFormTemplatePageComponent,
        data: {
          authorize: 'FormSchema:Create',
        },
      },
      {
        path: ':formSchemaId',
        children: [
          {
            path: '',
            component: ManageFormTemplatePageComponent,
            data: {
              authorize: 'FormSchema:View',
            },
          },
          {
            path: 'clone',
            component: NewFormTemplatePageComponent,
            data: {
              authorize: 'FormSchema:Create',
            },
          },
        ],
        data: {
          authorize: 'FormSchema:View',
        },
      },
    ],
  },
  {
    path: 'business-partner',
    component: ListAgencyPageComponent,
    data: {
      authorize: 'Agency:List',
    },
  },
  {
    path: 'program',
    component: ListProgramPageComponent,
    data: {
      authorize: 'Program:List',
    },
  },
  {
    path: 'my-business',
    component: ManageAgencyPageComponent,
    resolve: { ...myBusinessData, agencyId: MyAgencyResolver },
    data: {
      authorize: 'Agency:View',
    },
  },
  {
    path: 'report',
    component: ListReportPageComponent,
    data: {
      authorize: 'Report:List',
    },
  },
  {
    path: 'user',
    children: [
      {
        path: '',
        component: ListUserPageComponent,
        data: {
          authorize: 'User:List',
        },
      },
      {
        path: 'dashboard',
        component: ViewDashboardPageComponent,
        data: {
          authorize: 'Profile:View',
        },
      },
      {
        path: 'create-internal',
        component: NewUserInternalPageComponent,
        data: {
          authorize: 'InternalUser:Create',
        },
      },
      {
        path: 'create',
        component: NewUserPageComponent,
        data: {
          authorize: 'User:Create',
        },
      },
      {
        path: ':userId',
        children: [
          {
            path: '',
            component: ManageUserPageComponent,
            data: {
              authorize: 'User:View',
            },
          },
          {
            path: 'assign-role',
            component: NewUserRolePageComponent,
            data: {
              authorize: 'UserRole:Create',
            },
          },
        ],
      },
    ],
  },
  {
    path: 'business-partner',
    children: [
      {
        path: '',
        component: ListAgencyPageComponent,
        data: {
          authorize: 'Agency:List',
        },
      },
      {
        path: 'create',
        component: NewAgencyPageComponent,
        data: {
          authorize: 'Agency:Create',
        },
      },
      {
        path: ':agencyId',
        children: [
          {
            path: '',
            component: ManageAgencyPageComponent,
            data: {
              authorize: 'Agency:View',
            },
          },
          {
            path: 'role/create',
            component: NewRolePageComponent,
            canActivate: [FeatureGuard],
            data: {
              feature: UnityFeatureType.RoleManagement,
              authorize: 'Role:Create',
            },
          },
          {
            path: 'role/:roleId',
            component: ManageRolePageComponent,
            data: {
              authorize: 'Role:View',
            },
          },
          {
            path: 'user/create',
            component: NewUserPageComponent,
            data: {
              authorize: 'User:Create',
            },
          },
          {
            path: 'user/:userId',
            component: ManageAgencyUserPageComponent,
            data: {
              authorize: 'AgencyUser:View',
            },
          },
        ],
      },
    ],
  },
  {
    path: 'my-business',
    component: ManageAgencyPageComponent,
    resolve: { ...myBusinessData, agencyId: MyAgencyResolver },
    data: {
      authorize: 'Agency:View',
    },
  },
  {
    path: 'program',
    children: [
      {
        path: '',
        component: ListProgramPageComponent,
        data: {
          authorize: 'Program:List',
        },
      },
      {
        path: 'create',
        component: NewProgramPageComponent,
        data: {
          authorize: 'Program:Create',
        },
      },
      {
        path: ':programId',
        component: ManageProgramPageComponent,
        data: {
          authorize: 'Program:View',
        },
      },
    ],
  },
  {
    path: 'vendor',
    children: [
      {
        path: '',
        component: ListVendorPageComponent,
        data: {
          authorize: 'Vendor:List',
        },
      },
      {
        path: 'create',
        component: NewVendorPageComponent,
        data: {
          authorize: 'Vendor:Create',
        },
      },
      {
        path: ':vendorId',
        component: ManageVendorPageComponent,
        data: {
          authorize: 'Vendor:View',
        },
      },
    ],
  },
  {
    path: 'community',
    children: [
      {
        path: '',
        component: ListCommunityPageComponent,
        data: {
          authorize: 'Community:List',
        },
      },
      {
        path: 'create',
        component: NewCommunityPageComponent,
        data: {
          authorize: 'Community:Create',
        },
      },
      {
        path: ':communityId',
        component: ManageCommunityPageComponent,
        data: {
          authorize: 'Community:View',
        },
      },
    ],
  },
] as const satisfies InsideUnityRoute[];
